import {
  getRowGroupingFieldFromGroupingCriteria,
  GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
} from "@mui/x-data-grid-premium";
import { GroupingField } from "../../../../api/biClient.types.ts";

export const GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD_PREFIX = GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD.slice(0, -2);
/**
 * Get the fields that are used for row grouping
 * @param groupingFields - The grouping fields
 * @returns The field ids that are used for row grouping.
 * Example:
 * input = [{hideSummaries: false, name: "AccountCategory_3d9b8fe3"}]
 * output = ["__row_group_by_columns_group_AccountCategory_3d9b8fe3__"]
 */
export const getRowGroupingFieldsInMultipleRowGroupingColumnMode = (groupingFields: GroupingField[]): string[] => {
  if (groupingFields.length === 0) return [];
  return groupingFields.map((group) => getRowGroupingFieldFromGroupingCriteria(group.id));
};

export const getRowGroupingFieldsInSingleRowGroupingColumnMode = (groupingFields: GroupingField[]): string[] => {
  if (groupingFields.length === 0) return [];
  return [GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD];
};

export const separateFrozenColumns = (
  frozenColumns: string[]
): {
  groupedFrozenColumns: string[];
  nonGroupedFrozenColumns: string[];
} => {
  const groupedFrozenColumns = frozenColumns.filter((column) =>
    column.startsWith(GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD_PREFIX)
  );
  const nonGroupedFrozenColumns = frozenColumns.filter((column) => !groupedFrozenColumns.includes(column));
  return { groupedFrozenColumns, nonGroupedFrozenColumns };
};
